import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/recaudacion/detalles-contrato-folios-placas/';

/**
 * GET AlmacenesVehiculares
 * @returns {Promise<Array<object>>}
 */
export const getDetallesContratosFoliosPlacas = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET DetalleContratoFolioPlaca
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getDetalleContratoFolioPlaca = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST DetalleContratoFolioPlaca
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postDetalleContratoFolioPlaca = async (values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.post(baseURI, formattedValues);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH DetalleContratoFolioPlaca
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchDetalleContratoFolioPlaca = async (id, values) => {
  try {
    const formattedValues = getFormattedValues(values);
    const response = await API.patch(`${baseURI}${id}`, formattedValues);
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE DetalleContratoFolioPlaca
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteDetalleContratoFolioPlaca = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
